import { Component, inject, OnInit } from '@angular/core';
import {
  NbAutocompleteModule,
  NbCheckboxModule,
  NbFormFieldModule,
  NbInputModule,
  NbListModule,
  NbOptionModule,
  NbToggleModule,
} from '@nebular/theme';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { IInvestmentWizard } from '../wizard-interface';
import { ReactiveFormsModule } from '@angular/forms';
import { ScopeService } from '../../../../../@core/utils';
import { idMapToArray } from '../../../../../@core/utils/scope.service';
import { InvestmentWizardService } from '../../../../../@core/utils/investment-wizard-service';
import { KPI } from '../../../../../@core/api';

@Component({
  selector: 'app-investment-further-information',
  standalone: true,
  imports: [
    NbListModule,
    CommonModule,
    NbInputModule,
    NbFormFieldModule,
    TranslateModule,
    ReactiveFormsModule,
    NbToggleModule,
    NbAutocompleteModule,
    NbOptionModule,
    NbCheckboxModule,

  ],
  template: `
    <div class="d-flex flex-row">
      <nb-list>
        @for (furtherInfo of futherInfo$|async; track furtherInfo.id) {
          <nb-list-item (click)="setFurtherInformation(furtherInfo)" class="pointer"
                        [class.selected]="state()?.id === furtherInfo.id">
            {{ furtherInfo.name }}
          </nb-list-item>
        }
      </nb-list>
    </div>
  `,
  styleUrls: ['../wizard-index.component.scss'],
})
export class InvestmentFurtherInformationComponent implements OnInit, IInvestmentWizard {
  readonly stateKey = 'INVESTMENT_FURTHER_INFORMATION_SELECTION';
  state = () => this.wizardService.getState(this.stateKey);

  // dependencies
  private scope = inject(ScopeService);
  private wizardService = inject(InvestmentWizardService);

  // template avail state
  readonly futherInfo$ = this.scope.getInvestFurtherInfo$.pipe(idMapToArray());

  ngOnInit(): void {
    if (!this.state()?.id) {
      this.wizardService.blockCurrentStep('Please select an option');
    } else {
      this.wizardService.unblockCurrentStep();
    }
  }

  setFurtherInformation(furtherInfo: KPI.FurtherInformation): void {
    this.wizardService.setState('INVESTMENT_FURTHER_INFORMATION_SELECTION', furtherInfo);
    this.wizardService.next();
  }
}
